import { createFileRoute } from "@tanstack/react-router";
import { normalizeArchiveRequestPage } from "@/features/archive/archivePagination";
import { normalizeArchiveSearchQuery } from "@/features/archive/components/ArchiveSearchBar";
import {
  normalizeSearchScope,
  serializeSearchScope,
} from "@/features/search/searchScope";
import { ArchivePage } from "@/pages/ArchivePage";

export interface ArchiveSearch {
  page?: number;
  q?: string;
  scope?: "op";
}

export const Route = createFileRoute("/archive")({
  component: ArchivePage,
  validateSearch: (search: Record<string, unknown>): ArchiveSearch => {
    const page = Number(search.page);
    const query =
      typeof search.q === "string" ? normalizeArchiveSearchQuery(search.q) : "";
    const scope = serializeSearchScope(normalizeSearchScope(search.scope));
    return {
      page: normalizeArchiveRequestPage(page),
      ...(query ? { q: query } : {}),
      ...(scope ? { scope } : {}),
    };
  },
});
